var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-start" },
        [
          _vm.activateSpinner
            ? _c("spinner")
            : _c("div", { staticClass: "min-w-100" }, [
                _vm.isReport
                  ? _c("div", { staticClass: "body" }, [
                      _c("div", [
                        _c("div", { staticClass: "font-weight-bold" }, [
                          _c("i", {
                            staticClass: "icon fa fa-file",
                            staticStyle: { "margin-right": "15px" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("filter.nameFile") + " : ")),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.fileName ? _vm.fileName : "test.csv")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "my-2 py-2 line-success" }, [
                          _c("i", {
                            staticClass: "icon fa fa-check",
                            staticStyle: { "margin-right": "15px" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.results.ACCP) +
                                " " +
                                _vm._s(_vm.$t("company.fileLineAproove"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "my-2 py-2 line-update" }, [
                          _c("i", {
                            staticClass: "fa-solid fa-envelope-dot",
                            staticStyle: { "margin-right": "15px" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.results.UPDT) +
                                " " +
                                _vm._s(_vm.$t("company.fileLineUpdated"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "my-2 py-2 line-warning" }, [
                          _c("i", {
                            staticClass: "icon fa fa-pencil",
                            staticStyle: { "margin-right": "15px" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.results.EXST) +
                                " " +
                                _vm._s(_vm.$t("company.fileLineAlreadyExist"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "my-2 py-2 line-error" }, [
                          _c("i", {
                            staticClass: "icon fa fa-times",
                            staticStyle: { "margin-right": "15px" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.results.RFSL) +
                                " " +
                                _vm._s(_vm.$t("company.fileLineReject"))
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isReport
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-end mt-5" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "text-left" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "download-template-link",
                                attrs: { role: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.downloadMandateBulkTemplate.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "icon fa fa-download mr-2",
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("mandate.import_template")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "template-info-button",
                                attrs: {
                                  id: "mandate-template-info-" + _vm.randomId,
                                  type: "button",
                                  "aria-label": _vm.$t(
                                    "mandate.template_help_title"
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-info-circle",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  target:
                                    "mandate-template-info-" + _vm.randomId,
                                  triggers: "hover click",
                                  placement: "auto",
                                  boundary: "viewport",
                                  "custom-class": "mandate-template-popover",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.template_help_title"
                                              )
                                            )
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1736058424
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "template-help-content" },
                                  _vm._l(_vm.templateFields, function (field) {
                                    return _c(
                                      "div",
                                      {
                                        key: field,
                                        staticClass: "template-help-row",
                                      },
                                      [
                                        _c("strong", [_vm._v(_vm._s(field))]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.template_fields." +
                                                  field
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex mt-5 justify-content-end" },
                  [
                    !_vm.isReport
                      ? _c(
                          "b-col",
                          {
                            staticClass: "inline-flex",
                            attrs: { id: "btnFakeUpload" },
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "fake-import-button",
                                attrs: { for: "image_uploads" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.fileName
                                      ? _vm.$t("company.fileReplace")
                                      : _vm.$t("company.fileChoose")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.fileName
                              ? _c(
                                  "label",
                                  { attrs: { for: "image_uploads" } },
                                  [_vm._v(_vm._s(_vm.$t("company.fileNone")))]
                                )
                              : _c(
                                  "label",
                                  { attrs: { for: "image_uploads" } },
                                  [_vm._v(_vm._s(_vm.fileName))]
                                ),
                            _vm._v(" "),
                            _c("input", {
                              key: _vm.hiddenButtonKey,
                              ref: "file",
                              staticClass: "opacity-0",
                              attrs: {
                                type: "file",
                                id: "image_uploads",
                                accept: ".csv",
                                multiple: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleFileUpload()
                                },
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isReport
                      ? _c("div", { staticClass: "download" }, [
                          _c("div", { staticClass: "btn btn-primary" }, [
                            _c("a", { on: { click: _vm.downloadReport } }, [
                              _c("i", { staticClass: "icon fa fa-download" }),
                              _c(
                                "span",
                                { staticClass: "download-report-text" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("company.fileDownloadReport"))
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-5 col-lg-2 col-xl-2 col-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.cancel },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.isReport
                                  ? "OK"
                                  : _vm.$t("company.fileCancel")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.isReport
                      ? _c(
                          "div",
                          { staticClass: "mb-5 col-lg-2 col-xl-2 col-4" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    _vm.fileContent === "" ||
                                    _vm.fileName === "" ||
                                    _vm.showLoader,
                                },
                                on: { click: _vm.send },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("company.fileSend")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }